import { BaseContainerModel } from '../base-container.model';
import {bl_fi_generic_doc_pgw_txn_RowClass} from '../../dbschema';

export class GenericDocPgwTxnContainerModel extends BaseContainerModel {

  bl_fi_generic_doc_pgw_txn: bl_fi_generic_doc_pgw_txn_RowClass = new bl_fi_generic_doc_pgw_txn_RowClass();
}
